var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff4e4e;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-709 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(709 639)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(714 644)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.707,16.707a1,1,0,0,1-1.414,0L12,13.414,8.707,16.707a1,1,0,0,1-1.414-1.414L10.586,12,7.293,8.707A1,1,0,0,1,8.707,7.293L12,10.586l3.293-3.293a1,1,0,0,1,1.414,1.414L13.414,12l3.293,3.293A1,1,0,0,1,16.707,16.707Z",
    transform: "translate(-7 -7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.f77f6566ef958e402e4b09158ab910ab.svg";
export { ForwardRef as ReactComponent };